import Fuse from 'fuse.js';
import tippy from 'tippy.js';

let onHashChange = null;

export default () => {

  const touchEventsAvailable = !document.querySelector('html').classList.contains('no-touchevents');

  if (!document.querySelector('body.page-template-page-apps-home') && !document.querySelector('body.page-template-page-apps-detail')) {
    return;
  }

  const applyFilter = (filter) => {
    let titleElement = document.querySelector('#main-apps-title');
    let isAppHomeView = !!titleElement;

    document.querySelector('nav.filters').dataset.selectedFilter = filter || 'all';

    if (document.querySelector('.apps.filterable')) {
      delete document.querySelector('.apps.filterable').dataset.matchesCount;
      document.querySelector('.apps.filterable').classList.remove('display-all-apps');
    }


    if ((!filter) || (filter === 'all')) {
      document
        .querySelectorAll('.filters li.checked:not([data-filter="all"])')
        .forEach((el) => el.classList.remove('checked'));
      document
        .querySelector('.filters li[data-filter="all"]').classList.add('checked');
      document
        .querySelectorAll('.favourite-apps').forEach(el => el.classList.remove('hidden'));
      document
        .querySelectorAll(`.apps.filterable li.filtered-out`)
        .forEach(li => {
          li.classList.remove('filtered-out');
          li.classList.remove('invisible-if-many-results');
        });
      if (isAppHomeView) {
        titleElement.textContent = titleElement.dataset.placeholder
          .replace('{{category}}', 'Alle');
      }

      return;
    }

    if (isAppHomeView) {
      titleElement.textContent = titleElement.dataset.placeholder
        .replace(
          '{{category}}',
          document.querySelector(`li[data-filter="${filter}"]`).textContent.trim()
        );


      document
        .querySelector('.favourite-apps')
        .classList.add('hidden');
    }


    document
      .querySelectorAll(`ul.apps.filterable`)
      .forEach((filterable) => {
        let matchesCount = 0;
        filterable
          .querySelectorAll(`li[data-categories]`).forEach((el) => {
            let categories = el.dataset.categories.split(',');
            let matches = [filter].every(v => categories.includes(v));
            if (matches) {
              matchesCount++;
              el.classList.remove('filtered-out');
              if (matchesCount > 3) {
                el.classList.add('invisible-if-many-results');
              }
            } else {
              el.classList.add('filtered-out');
            }
          }
        );
        let noItemsFound = filterable.closest('.apps-overview').querySelector('.no-items-found');
        if (!filterable.querySelector('li[data-categories]:not(.filtered-out)') && noItemsFound) {
          noItemsFound.classList.remove('hidden');
        } else if (noItemsFound) {
          noItemsFound.classList.add('hidden');
        }
        filterable.dataset.matchesCount = matchesCount;

      });
  };

  const checkFilter = (filter) => {
    if (!filter) {
      filter = 'all';
    }
    document.querySelectorAll('.filters ul li').forEach(li => {
      li.classList.remove('checked');
    });
    document.querySelector(`.filters ul li[data-filter="${filter}"]`).classList.add('checked');
  };

  const applyFilterByName = (filter) => {
    filter = filter.replace(/^#/, '');
    checkFilter(filter);
    applyFilter(filter);
  };

  if (!onHashChange) {
    // only apply once
    window.addEventListener('hashchange', () => {
      if (document.querySelector('body.page-template-page-apps-home')) {
        applyFilterByName(window.location.hash);
      }
    }, false);
    onHashChange = true;
  }

  const toggleFilterOnClick = (ev) => {
    let li = ev.target;
    let { filter } = li.dataset;
    if (!touchEventsAvailable) {
      document.querySelector('.apps-overview').scrollIntoView({ behavior: window.JS_SCROLL_BEHAVIOR });
    }
    li.closest('.filters').querySelectorAll('li.checked').forEach(li => li.classList.remove('checked'));
    li.classList.add('checked');
    li.closest('.filters').classList.remove('expanded');
    window.location.hash = filter;
  };

  const followFilterLinkOnClick = (ev) => {
    let li = ev.target;
    let { filter } = li.dataset;
    let url = `/integrationen#${filter}`;
    (window.Turbo) ? window.Turbo.visit(url) : document.location = url;
  };

  const appSearchIndex = () => {
    return [...document.querySelectorAll('.apps li[id]')].map((li) => {
      return {
        title: li.querySelector('h5').textContent.trim(),
        category: li.querySelector('.h4').textContent.trim(),
        categories: li.dataset.categories.split(','),
        id: li.getAttribute('id')
      };
    });
  };

  const restoreAppSortOrder = () => {
    document.querySelectorAll('#main-apps li').forEach((li) => {
      li.style.order = null;
    });
  };

  const restoreApps = () => {
    document.querySelectorAll('#main-apps li').forEach((li) => {
      li.style.order = null;
      li.classList.remove('filtered-out');
      delete li.dataset.searchScore;
    });
  };

  const onChangeSorting = (ev) => {
    const apps = document
      .querySelector(ev.target.dataset.target)
      .querySelectorAll('li');
    if (ev.target.value === 'alphabetical') {
      const sortedApps = [
        ...apps
      ].sort((a, b) => {
        return a.querySelector('h5').textContent.trim().localeCompare(
          b.querySelector('h5').textContent.trim()
        );
      });
      sortedApps.forEach((li, i) => li.style.order = i);
    } else {
      restoreAppSortOrder();
    }
  };

  const fuse = new Fuse(appSearchIndex(), {
    includeScore: true,
    keys: [
      'title',
      {
        name: 'category',
        weight: 0.25
      },
      {
        name: 'categories',
        weight: 0.1
      }
    ]
  });

  const performAppSearch = (ev) => {
    document.querySelector('.apps-overview').classList.add('search-mode');
    const searchInput = ev.target.value;

    if (!searchInput || document.activeElement !== ev.target) {
      restoreApps();
      document.querySelector('.apps-overview').classList.remove('search-mode');
      return;
    }

    const result = fuse.search(searchInput);
    restoreApps();
    result.forEach((r, i) => {
      let { id } = r.item;
      let el = document.getElementById(id);
      el.style.order = i;
      el.dataset.searchScore = r.score;
    });
    document.querySelector('.main-apps-search-results span').textContent = searchInput.trim();
  };

  document
    .querySelectorAll('.page-template-page-apps-home .filters li')
    .forEach(el => el.addEventListener('click', toggleFilterOnClick));

  document
    .querySelectorAll('.page-template-page-apps-detail .filters li')
    .forEach(el => el.addEventListener('click', followFilterLinkOnClick));

  document
    .querySelectorAll('select#app-sorting')
    .forEach(el => el.addEventListener('change', onChangeSorting));

  document
    .querySelectorAll('.search-input-field')
    .forEach(el => el.addEventListener('keyup', performAppSearch));

  // https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
  const markCurrentPictureIsViewed = () => {
    let markCenteredVisibleElement = (root, selector, cb) => {
      let observer = new IntersectionObserver((entries, observer) => {
          root.querySelectorAll(selector).forEach(el => el.classList.remove('current'));
          entries[0].target.classList.add('current');
          if (typeof cb === 'function') {
            cb(entries, observer);
          }
        }, {
          root,
          rootMargin: '0px',
          threshold: 1.0
        }
      );
      root.querySelectorAll(selector).forEach(el => observer.observe(el));
    };
    let pictureContainer = document.querySelector('.pictures');
    markCenteredVisibleElement(pictureContainer, 'li', _ => {
      let parent = pictureContainer.querySelector('ul');
      let pos = [...parent.children].findIndex(item => item === pictureContainer.querySelector('li.current'));
      pictureContainer.closest('.pictures-wrapper').querySelectorAll('.indicators li.active').forEach(el => el.classList.remove('active'));
      pictureContainer.closest('.pictures-wrapper').querySelectorAll('.indicators ul li')[pos].classList.add('active');
    });
  };

  document.querySelectorAll('.display-all-apps-button').forEach(el => el.addEventListener('click', ev => {
    ev.target.closest('ul.apps').classList.add('display-all-apps');
  }));

  const arrowsOnClick = ev => {
    let target = ev.target;
    target = (target.closest('.arrow-left')) ? target.closest('.arrow-left') : target.closest('.arrow-right');
    const direction = (target.classList.contains('arrow-left')) ? -1 : 1;
    let indicator = target.closest('.pictures-wrapper').querySelector('.indicators ul li.active');
    let pos = Number(indicator.dataset.pos) + direction;

    let { length } = target.closest('.pictures-wrapper').querySelectorAll('.indicators ul li');

    if (pos >= length) {
      pos = 0;
    } else if (pos < 0) {
      pos = length - 1;
    }
    showPicture(pos, target);
  };

  const showPicture = (pos, target) => {
    let indicators = target.closest('.pictures-wrapper').querySelectorAll('.indicators ul li');
    let pictures = target.closest('.pictures-wrapper').querySelector('.pictures');
    let pic = pictures.querySelectorAll('ul li')[pos];

    let { offsetLeft } = pic.closest('li');
    let options = {
      left: offsetLeft,
      behavior: window.JS_SCROLL_BEHAVIOR
    };
    pictures.scrollTo(options);
    indicators.forEach(el => el.classList.remove('active'));
    indicators[pos].classList.add('active');
  };


  if (window.location.hash) {
    let filter = document.querySelector(`.filters ul li[data-filter="${window.location.hash.replace(/^\#/, '')}"]`);
    if (filter) {
      applyFilterByName(window.location.hash);
      // this needs to be a bit later, otherwise it fill not be triggered if site is invoked via link
      setTimeout(_ => {
        filter.click();
      }, 100);
    } else {
      applyFilterByName(window.location.hash);
    }
  } else if (document.querySelector('.filters ul li.checked')) {
    applyFilterByName(document.querySelector('.filters ul li.checked').dataset.filter);
  } else {
    applyFilterByName('');
  }

  if (document.querySelector('.pictures')) {
    if (touchEventsAvailable) {
      // IntersectionObserver not working as expected on Desktop Safari (2021)… so use it only in mobile/tablet views
      markCurrentPictureIsViewed();
    }
    document.querySelectorAll('.pictures-wrapper .indicators li').forEach(el => el.addEventListener('click', ev => {
      let target = ev.currentTarget;
      let { pos } = target.dataset;
      ev.preventDefault();
      showPicture(pos, target);
    }));
    document.querySelectorAll('.arrow-left, .arrow-right').forEach(el => el.addEventListener('click', arrowsOnClick));
  }
};
